import { createSlice } from '@reduxjs/toolkit';

const singleOrderSlice = createSlice({
    name: 'singleOrder',
    initialState: {
        data: null,
        loading: false,
        error: null,
        id: null,
        copyOrder: false  // Added new state with default false
    },
    reducers: {
        fetchSingleOrderStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchSingleOrderSuccess(state, action) {
            state.data = action.payload.data;
            state.id = action.payload.id;
            state.loading = false;
        },
        fetchSingleOrderFailure(state, action) {
            state.error = action.payload;
            state.loading = false;
        },
        clearSingleOrder(state) {
            state.data = null;
            state.id = null;
            state.error = null;
            state.copyOrder = false; // Reset to false when clearing
        },
        // New reducers for copyOrder state
        setCopyOrder(state, action) {
            state.copyOrder = action.payload;
        },
        toggleCopyOrder(state) {
            state.copyOrder = !state.copyOrder;
        }
    }
});

export const {
    fetchSingleOrderStart,
    fetchSingleOrderSuccess,
    fetchSingleOrderFailure,
    clearSingleOrder,
    setCopyOrder,
    toggleCopyOrder
} = singleOrderSlice.actions;

export default singleOrderSlice.reducer;